// extracted by mini-css-extract-plugin
module.exports = {"title":"List_title__1qvDY","count":"List_count__RtucA","table":"List_table__2oS5y","status":"List_status__330mC","disabled":"List_disabled__3e73l"};